<section class="home" id="home" *ngIf="content$ | async as content">
  <div class="home__bg-slider">
    <ng-container *ngIf="content?.heroImages?.length; else defaultImages">
      <div class="home__bg-slide" *ngFor="let img of content.heroImages"
        [ngStyle]="{'background-image': 'url(' + absoluteUrl(img) + ')'}">
      </div>
    </ng-container>
    <ng-template #defaultImages>
      <div class="home__bg-slide"
        [style.background-image]="content?.heroImage ? 'url(' + absoluteUrl(content?.heroImage) + ')' : 'url(https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&q=80&w=1920)'">
      </div>
      <div class="home__bg-slide"
        style="background-image: url('https://images.unsplash.com/photo-1517433670267-08bbd4be890f?auto=format&fit=crop&q=80&w=1920')">
      </div>
      <div class="home__bg-slide"
        style="background-image: url('https://images.unsplash.com/photo-1495147466023-ac5c588e2e94?auto=format&fit=crop&q=80&w=1920')">
      </div>
      <div class="home__bg-slide"
        style="background-image: url('https://images.unsplash.com/photo-1555507036-ab1e4006aaeb?auto=format&fit=crop&q=80&w=1920')">
      </div>
    </ng-template>
  </div>
  <div class="home__overlay"></div>
  <div class="home__content container text-center">
    <span class="home__subtitle">{{ content?.heroSubtitle || 'Artisanal & Local' }}</span>
    <h1 class="home__title">{{ content?.heroTitle || 'The Husk Bakery' }}</h1>
    <p class="home__description">
      {{ content?.announcement || 'Experience the warm, golden crust of authentic Australian sourdough and our selection of hand-crafted morning pastries, baked fresh daily.' }}
    </p>
    <div class="home__actions">
      <a routerLink="/products" class="btn btn-outline home__btn-outline">View All Products</a>
    </div>
  </div>
</section>

<app-menu></app-menu>
<app-about></app-about>